import { useDailyInsurance, getProductFrom, getSkuPrice, isWeekday, skuIdPrice, isHourly } from './utils'
import { 
  calculateHoursCount,
  hourPriceOnDay,
  insuranceMandatoryPrice,
  insuranceCancellationPrice,
  insuranceRentalPrice,
  replacementCardPrice,
  couponValue
// eslint-disable-next-line import/no-duplicates
} from './booking'
// eslint-disable-next-line import/no-duplicates
import BookingLib, { isWeekdayEqualToWeekendPrice } from './booking'

const buildBookingOrder = (person, booking, skus, intl, overrideHours, email) => {
  const { membership, passType } = person
  const membershipType = !membership || (passType && membership.type !== passType)
    ? passType
    : membership.type
  const product = getProductFrom(membershipType)
  const hoursCount = calculateHoursCount(booking.whenStartTime, booking.whenEndTime)

  const bookingItems = []

  // Claculate days which are considered special weekeends from override hours array
  const specialWeekends = overrideHours.filter(d => d.isWeekend)

  // Pass
  const isMembershipUpgrade = membership && membership.type !== passType
  if (product && (!membership || isMembershipUpgrade)) {
    bookingItems.push({
      product,
      localizedName: intl.formatMessage({ id: `passTypes.${membershipType}` }),
      localizedPrice: `${intl.formatNumber(getSkuPrice(membershipType, 'skuId', skus), { minimumFractionDigits: 2 })} DKK`,
      skuId: getProductFrom(membershipType).skuId,
      quantity: 1
    })
  }

  // Hours
  const hoursSkuToUse = isWeekday(new Date(booking.whenStartTime), specialWeekends) ? 'hourRateWeekdaysSkuId' : 'hourRateWeekendsSkuId'
  const hoursPrice = hourPriceOnDay(product, booking, skus, specialWeekends) * hoursCount
  const localizedName = intl.formatMessage({ id: 'booking.cart.hourRate', defaultMessage: 'Hour Rate' })
  const showWeekendRate = !isWeekday(new Date(booking.whenStartTime), specialWeekends)
    && !isWeekdayEqualToWeekendPrice(product, skus)
  const localizedRate = !showWeekendRate ? '' : intl.formatMessage({ id: 'booking.cart.weekendRate', defaultMessage: ', (Rate: weekend/holiday)' })

  bookingItems.push({
    product,
    localizedName: `${localizedName}${localizedRate}`,
    localizedPrice: `${intl.formatNumber(hoursPrice, { minimumFractionDigits: 2 })} DKK`,
    skuId: getProductFrom(person.passType || person.membership.type)[hoursSkuToUse],
    quantity: hoursCount
  })

  // INSURANCE
  // const mandatoryInsuranceSkuId = useDailyInsurance(person.passType)
  //   ? getProductFrom('insurance').mandatoryDailySkuId
  //   : getProductFrom('insurance').mandatoryYearlySkuId

  // bookingItems.push({
  //   product: getProductFrom('insurance'),
  //   localizedName: useDailyInsurance(person.passType || person.membership.type)
  //     ? intl.formatMessage({ id: 'booking.cart.insuranceDailyMandatory', defaultMessage: 'Mandatory daily insurance' })
  //     : intl.formatMessage({ id: 'booking.cart.insuranceYearlyMandatory', defaultMessage: 'Mandatory yearly insurance' }),
  //   localizedPrice: `${intl.formatNumber(insuranceMandatoryPrice(person, skus), { minimumFractionDigits: 2 })} DKK`,
  //   skuId: mandatoryInsuranceSkuId,
  //   quantity: 1
  // })

  if (person.insuranceCancellation) {
    bookingItems.push({
      product: getProductFrom('insurance'),
      localizedName: intl.formatMessage({ id: 'booking.cart.insuranceCancellation', defaultMessage: 'Cancellation insurance' }),
      localizedPrice: `${intl.formatNumber(insuranceCancellationPrice(person, skus), { minimumFractionDigits: 2 })} DKK`,
      skuId: getProductFrom('insurance').cancellationSkuId,
      quantity: 1
    })
  }

  if (person.rental && person.rental.insurance) {
    bookingItems.push({
      product: getProductFrom('insurance'),
      localizedName: intl.formatMessage({ id: 'booking.cart.insuranceRental', defaultMessage: 'Rental insurance' }),
      localizedPrice: `${intl.formatNumber(insuranceRentalPrice(person, skus), { minimumFractionDigits: 2 })} DKK`,
      skuId: getProductFrom('insurance').rentalSkuId,
      quantity: 1
    })
  }

  // REPLACEMENT CARD
  if (person.replacementCard) {
    bookingItems.push({
      product: getProductFrom('misc'),
      localizedName: intl.formatMessage({ id: 'booking.cart.replacementCard', defaultMessage: 'Replacement card' }),
      localizedPrice: `${intl.formatNumber(replacementCardPrice(person, skus), { minimumFractionDigits: 2 })} DKK`,
      skuId: getProductFrom('misc').replacementCardSkuId,
      quantity: 1
    })
  }

  // INSTRUCTION
  if (person.instruction && person.instruction.skuId) {
    const instructionPrice = skuIdPrice(person.instruction.skuId, skus)
    bookingItems.push({
      product: getProductFrom('instruction'),
      localizedName: intl.formatMessage({ id: `booking.cart.instruction.${person.instruction.skuName}` }),
      localizedPrice: `${intl.formatNumber(instructionPrice, { minimumFractionDigits: 2 })} DKK`,
      skuId: person.instruction.skuId,
      quantity: 1
    })
  }

  // RENTAL
  if (person.rental && person.rental.equipment) {
    Object.keys(person.rental.equipment).forEach(key => {
      const equipmentSkuId = person.rental.equipment[key]

      if (equipmentSkuId) {
        const rentalPrice = skuIdPrice(equipmentSkuId, skus)

        bookingItems.push({
          product: getProductFrom('rental'),
          localizedName: intl.formatMessage({
            id: `booking.person.rental.${key}`
          }),
          localizedPrice: `${intl.formatNumber(rentalPrice, { minimumFractionDigits: 2 })} DKK`,
          skuId: getProductFrom('rental')[equipmentSkuId],
          quantity: 1
        })
      }
    });
  }

  // Voucher discount
  if (person.appliedVoucher && !person.couponInfo) {
    bookingItems.push({
      product: { id: 'discount' },
      localizedName: 'Voucher',
      localizedPrice: `${intl.formatNumber(BookingLib.voucherValue(person, booking, skus, overrideHours, email), { minimumFractionDigits: 2 })} DKK`,
      skuId: '',
      quantity: 1
    })
  }

  // Coupon discount
  if (person.couponInfo && !person.appliedVoucher) {
    bookingItems.push({
      product: { id: 'discount' },
      localizedName: intl.locale === 'en' ? 'Coupon' : 'Kupon',
      localizedPrice: `${intl.formatNumber(couponValue(person, booking, skus, overrideHours), { minimumFractionDigits: 2 })} DKK`,
      skuId: '',
      quantity: 1
    })
  }

  // console.debug(JSON.stringify(bookingItems))

  return {
    // passType: product.id,
    passTypeSkuId: 'DEPRECATED', // product.skuId
    voucher: person.voucher && person.voucher.trim(),
    voucherId: person.appliedVoucher && person.appliedVoucher.id,
    person,
    items: bookingItems
    // metaData: {
    // }
  }
}

export default buildBookingOrder